// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rBTVg","gridSection":"styles_gridSection__rrZ1X"};